import { render } from "./GridContatoColunasSelector.vue?vue&type=template&id=3c8523d4&scoped=true"
import script from "./GridContatoColunasSelector.vue?vue&type=script&lang=js"
export * from "./GridContatoColunasSelector.vue?vue&type=script&lang=js"

import "./GridContatoColunasSelector.vue?vue&type=style&index=0&id=3c8523d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8523d4"]])

export default __exports__